<div class="row login" id="back" role="main">
  <div class="d-none d-lg-flex col-lg-8 align-items-center p-0 banner-sec container-image">
    <div id="loginSlider" class="carousel slide-fade w-100 h-100" data-ride="carousel">
      <div class="carousel-inner d-flex h-100" role="listbox">
        <div class="carousel-item active">
          <div class="slider-img img-1"></div>
          <img class="d-block img-fluid mx-auto" src="assets/images/Communicare_Landing_banner.jpg" alt="First slide" />
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex col-lg-4 shadow align-items-center p-4 mx-auto rightLoginSet">
    <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
      <div class="clearfix text-right" *ngIf="showLanguage">
        <a class="clsLangBtn" (click)="showLanguageDialog()" role="button" title="choose language translater to change English or Spanish">
          <div class="menuIcons d-inline-block position-relative align-middle">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#0059bf">
              <path
                d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z" />
            </svg>
          </div> 
          <span class="d-inline-block align-middle">
            English
          </span>
        </a>
      </div>
      <div class="clearfix text-left logo-group lg-mb-50">
        <div class="form-group mb-4">
          <div class="logo-group">
            <span class="logo-img d-block text-center">
              <img src="assets/images/Communicare_Logo_Green.png" class="cfaLogoTop" alt="COMET Logo" />
            </span>
            <span class="logo-text">
              <h1 class="font-weight-bold logo-title"> Log in to Communication & Operations Mobile Engagement Tool </h1>
            </span>
          </div>
        </div>
      </div>

      <div class="clearfix loginBottomSet">
        <div class="login-content" *ngIf="!isOtpSent">
          <form (ngSubmit)="login('login')" novalidate [formGroup]="loginForm">
            <div class="clearfix" *ngIf="!loginPass">
              <div class="form-group">
                <label aria-labelledby="username" for="username" class="intake-form-labels">Username </label>
                <input
                  class="Inputs"
                  autofocus
                  type="mail"
                  formControlName="email"
                  placeholder="Email"
                  name="email"
                  id="username"
                  tabindex="0"
                  required />
              </div>
              <div class="clearfix">
              </div>
              <div class="clearfix text-center mt-4">
                <p-button
                  role="button"
                  type="submit"
                  [disabled]="!loginForm.valid"
                  class="loginbutton"
                  tabindex="0"
                  ><em *ngIf="submitStatus ==='Please wait ...'" class="fa fa-spinner fa-spin me-2"></em> {{ submitStatus }}</p-button
                >
              </div>
            </div>
          </form>
          <div *ngIf="loginPass">
            <form (ngSubmit)="login('password')" novalidate [formGroup]="passwordForm">
              <div class="form-group no-mar">
                <label aria-label="Enter your" for="password" class="intake-form-labels w-100"
                  >Password
                </label>
                <input
                  class="Inputs password"
                  #showhideinput
                  formControlName="password"
                  type="password"
                  placeholder="Password"
                  name="password"
                  id="password"
                  tabindex="0"
                  required />
                <i class="fa fa-eye" aria-hidden="true" (click)="toggleShow()"></i>
                <label aria-labelledby="password" for="password" class="intake-form-labels w-100">
                  <a href="javascript:void(0)" (click)="routeToChangePassword()" class="btn-link forget">
                  Forgot Password?</a>
                  </label>
              </div>
              <div class="form-group clearfix mb-30 clsMin-23 pt-10">
                <div class="checkbox">
                  <p-checkbox
                    class="checklabelbox"
                    name="conditions"
                    formControlName="conditions"
                    value="yes"
                    inputId="ch"
                    aria-checked="false">
                  </p-checkbox>
                  <label class="checklabel" for="ch">
                    I have read and agree to the
                    <a target="_blank" routerLink="/terms-and-conditions-and-privacy-policy" class="textunderline">Terms and Conditions and Privacy Policy</a>.
                  </label>
                </div>
              </div>
              <div class="clearfix text-center mt-4">
                <p-button role="button" type="submit" [disabled]="!passwordForm.valid" class="Passwordbutton" tabindex="0">
                  <em *ngIf="submitStatus ==='Please wait ...'" class="fa fa-spinner fa-spin me-2"></em>
                  {{ submitStatus }}
                </p-button>
              </div>
              <a href="javascript:;" (click)="onCancel()"> Back to Username </a>
            </form>
          </div>          
        </div>

        <div class="login-content" *ngIf="isOtpSent">
          <h4 class="text-center text-20"> One-Time Password Verification </h4>
          <p class="text-center text-13"  role="alert" *ngIf="isMailOtp" > Enter the verification code sent to the email {{loginForm.value.email | emailMask}} </p>
          <p class="text-center text-13" role="alert"  *ngIf="!isMailOtp" > Enter the verification code sent to your registered Mobile Number</p>
          <form (ngSubmit)="sendOtp()" novalidate [formGroup]="otpForm">
            <div class="clearfix">
              <div class="form-group">
                  <div class="clearfix text-center pb-15">
                    <ng-otp-input #ngOtpInput 
                    [config]="{length:6, allowNumbersOnly: true, isPasswordInput: false}" 
                    (onInputChange)="patchOTP($event)"></ng-otp-input>
                  </div>
                  <div class="clearfix text-center notranslate">
                    {{time}}
                   </div>
                  <div class="clearfix text-center">
                    <p *ngIf="isTimerDone" class="text-center mb-10"> Didn't receive an OTP code? <a href="javascript:;" (click)="onResend()" title="Didn't receive an OTP code">Resend OTP code.</a> </p>
                    <a href="javascript:;" (click)="onCancel()"> Back to Username </a>
                  </div>
              </div>

              <div class="clearfix text-center mt-4">
                <p-button
                  role="button"
                  type="submit"
                  [disabled]="!otpForm.valid"
                  class="loginbutton"
                  tabindex="0"
                  ><em *ngIf="submitSecretStatus ==='Please wait ...'" class="fa fa-spinner fa-spin me-2"></em>{{ submitSecretStatus }}</p-button
                >
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="clearfix text-center mt-3">
        <a routerLink="/help" class="textunderline" tabindex="0">Help &amp; Support</a>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Personalized Integrated Citizen Services (PICS) Terms &amp; conditions
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body termscondition">
    <p class="mb-2">
      These Terms and Conditions constitute a legally binding agreement (“Agreement”) made between you, whether
      personally as a professional, or on behalf of an entity you represent (“You” or “Customer”) and Cardinality.AI
      whose principal place of business is VA, U.S.A, (“Cardinality”, “we,” “us” or “our”), concerning your access to
      and contracting a PICS offering (“Product”).
    </p>
    <p class="mb-2">
      You agree that by contracting our Product, you have read, understood, and agree to be bound by these Terms and
      Conditions, which may be executed via electronic signature, electronic online communications, or via emailed
      PDF-format document.
    </p>
    <p class="mb-2">
      You confirm that you are fully able and entitled to accept these Terms and Conditions governing the purchase of
      the Product and are authorized to do so on behalf of the Customer. This service is only available for
      professionals and companies, and you represent that you are not a consumer or a minor.
    </p>
    <p class="mt-4 mb-2">
      <strong>CONFIDENTIALITY AGREEMENT</strong>
    </p>
    <p class="mb-2">
      You agree that you shall maintain strictly confidential, and shall not reveal nor by any means transfer to a third
      party, or use any and all information related to the Services, products, materials, and prototypes, and any
      technical documentation that forms part of the Know-how of Product, or that it has received from third parties, or
      any other information to which you have access by virtue of accepting these terms.
    </p>
    <p class="mb-2">
      You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service,
      violate any laws in your jurisdiction (including but not limited to copyright laws).
    </p>
    <p class="mt-4 mb-2">
      <strong>DATA USAGE & PROTECTION</strong>
    </p>
    <p class="mb-2">
      You agree to comply with applicable data usage and protection laws in relation to the Product. Data usage policy
      is primarily concerned with privacy and compliance and exists to ensure that the data you collect, use, and store
      is not abused. Legislation such as HIPAA have very strict guidelines on how customer data can 
      be used, and non-compliance can have serious consequences.
    </p>
    <p class="mb-2">
      This ties into the access policy, since employees, contractors, and other workers should only be able to access
      data they require to do their jobs. You should also have strict guidelines in place regarding who is able to
      update data and under what circumstances they are allowed to do so.
    </p>
    <p class="mb-2">
      Data Usage Policy is designed to let you know how we collect, use, and disclose information through the websites,
      mobile applications, and other online services and products.
    </p>
    <p class="mb-2">
      All data obtained and held by us must be processed according to a set of core principles. In accordance with these
      principles, we will ensure that:
    </p>
    <div class="ms-4">
      <ul>
        <li>Processing will be fair, lawful and transparent</li>
        <li>Data collected for specific, explicit, and legitimate purposes</li>
        <li>
          Data collected will be adequate, relevant and limited to what is necessary for the purposes of processing
        </li>
        <li>
          Data will be kept accurate and up to date. Data which is found to be inaccurate will be rectified or erased
          without delay
        </li>
        <li>Data is not kept for longer than is necessary for its given purpose</li>
        <li>
          Data will be processed in a manner that ensures appropriate security of personal data including protection
          against unauthorised or unlawful processing, accidental loss, destruction or damage by using appropriate
          technical or organisation measures
        </li>
      </ul>
    </div>
    <p class="mt-4 mb-2">
      <strong>DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</strong>
    </p>
    <p class="mb-2">
      We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or
      error-free.
    </p>
    <p class="mb-2">
      We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.
    </p>
    <p class="mb-2">
      You agree that from time to time we may remove the service for indefinite periods of time or cancel the service at
      any time, without notice to you.
    </p>
    <p class="mb-2">
      You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all
      products and services delivered to you through the service are (except as expressly stated by us) provided ‘as is’
      and ‘as available’ for your use, without any representation, warranties or conditions of any kind, either express
      or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a
      particular purpose, durability, title, and non-infringement.
    </p>
    <p class="mt-4 mb-2">
      <strong>INDEMNIFICATION</strong>
    </p>
    <p class="mb-2">
      You agree to indemnify, defend and hold harmless Cardinality.AI and our parent, subsidiaries, affiliates,
      partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers,
      interns and employees, harmless from any claim or demand, including reasonable attorneys’ fees, made by any
      third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by
      reference or your violation of any law or the rights of a third-party.
    </p>
    <p class="mt-4 mb-2">
      <strong>SEVERABILITY</strong>
    </p>
    <p class="mb-2">
      If any provision of these Terms of Service is determined to be unlawful, void, or unenforceable, such provision
      shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion
      shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and
      enforceability of any other remaining provisions.
    </p>
    <p class="mt-4 mb-2"><strong>GOVERNING LAW</strong></p>
    <p class="mb-2">
      These Terms shall be governed and construed in accordance with the laws of Virginia, United States, without regard
      to its conflict of law provisions.
    </p>
    <p class="mb-2">
      Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If
      any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these
      Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and
      supersede and replace any prior agreements we might have had between us regarding the Service.
    </p>
    <p class="mt-4 mb-2"><strong>CHANGES</strong></p>
    <p class="mb-2">
      We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is
      material we will provide at least 30 days notice prior to any new terms taking effect. What constitutes a material
      change will be determined at our sole discretion.
    </p>
    <p class="mb-2">
      By continuing to access or use our Service after any revisions become effective, you agree to be bound by the
      revised terms. If you do not agree to the new terms, you are no longer authorized to use the Service.
    </p>

    <p class="mt-4 mb-2"><strong>CONTACT US</strong></p>
    <p class="mb-2">If you have any questions about these Terms, please contact us.</p>
  </div>
</ng-template>

<p-dialog class="clsDialogCloseIconRemove"
  [visible]="visible"
  [modal]="true"
  [focusTrap]="true"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '60vw' }" 
  [resizable]="false"
    [attr.role]="visible ? 'dialog' : null"
  [attr.aria-labelledby]="visible ? 'dialog-title-trans' : null"
  [attr.aria-describedby]="visible ? 'dialog-content-trans' : null">
  <ng-template pTemplate="header">
    <div class="d-flex align-items-center justify-content-between">
      <div class="clearfix">
        <h2 id="dialog-title-trans" class="clearfix no-mar clsDialogTitle">
              Automatic Translation Disclaimer<br>
              Descargo de responsabilidad por traducción automática
          </h2>
      </div>
      <button #accept type="button" class="btn btn-link no-mar clsCloseBtn" (click)="close()" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
              <path
                  d="M38.57 29.0019L56.5131 11.0588C58.4956 9.07625 58.4956 5.86208 56.5131 3.88265L54.1211 1.49061C52.1379 -0.492534 48.9238 -0.492534 46.9443 1.49061L29.0019 19.4331L11.0588 1.48689C9.07625 -0.495631 5.86208 -0.495631 3.88265 1.48689L1.48689 3.87893C-0.495631 5.86208 -0.495631 9.07625 1.48689 11.0557L19.4331 29.0019L1.49061 46.9443C-0.492534 48.9275 -0.492534 52.1416 1.49061 54.1211L3.88265 56.5131C5.86518 58.4956 9.07934 58.4956 11.0588 56.5131L29.0019 38.57L46.9443 56.5131C48.9275 58.4956 52.1416 58.4956 54.1211 56.5131L56.5131 54.1211C58.4956 52.1379 58.4956 48.9238 56.5131 46.9443L38.57 29.0019Z" />
          </svg>
      </button>
  </div>
  </ng-template>

  <div class="clearfix mb-4 clsTranslation">
    <p class="mb-3" id="dialog-content-trans">
      The State of West Virginia provides automatic translation for Communication & Operations Mobile Engagement Tool into two
      languages, courtesy of Google Translate. Please remember, though, that the English language
      version is considered the most accurate. In the event of a disagreement or discrepancy between
      the translation and the original English version of this web site or any notice or disclaimer, the
      original English version will prevail.
      <br><br>
      El Estado de West Virginia proporciona traducción automática para Communication & Operations Mobile Engagement Tool a dos
      idiomas, por cortesía de Google Translate. No obstante, recuerde que la versión en inglés se
      considera la más exacta. En caso de desacuerdo o discrepancia entre la traducción y la versión
      original en inglés de este sitio web o cualquier aviso o descargo de responsabilidad,
      prevalecerá la versión original inglés.
    </p>
  </div>
  
  <ng-template pTemplate="footer">
    <div class="clearfix sep-top clsMarMinus"></div>
    <div class="clearfix pt-3 text-right">
      <button type="button" class="btn btn-primary" (click)="acceptLanguage()"> Accept / Aceptar </button>
      <button type="button" class="btn btn-cancel ms-3" (click)="close()"> Do Not Accept / No Aceptar </button>
    </div>
  </ng-template>
</p-dialog>